export interface CreateAllocationWorkOrder {
	allocationId: number;
	quantity: number;
	workOrderId: string;
}

export class CreateAllocationWorkOrder implements CreateAllocationWorkOrder {	
	constructor(data?: Partial<CreateAllocationWorkOrder>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}